import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { Export16 } from 'ui/icons';
import {
  PERFORMANCE_OVER_TIME,
  EXPORT_CSV,
  PERFORMANCE_OVER_TIME_TOOLTIP,
  PERFORMANCE_OVER_TIME_EXPORT_HEADERS,
  PERFORMANCE_OVER_TIME_EXPORT_SUCCESS,
} from 'modules/intelligentInsights/constants';
import { heading5, spacing } from 'ui/theme';
import { Help16 } from 'ui/icons';
import { Tooltip } from 'ui/tooltip';
import { Button, BUTTON_VARIANTS, BUTTON_SIZES } from 'ui/button';
import { useFroInsightsCoreContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';
import { getPerformanceDataExport } from 'modules/intelligentInsights/frequencyOptimization/components/performanceOverTime/utils';
import { downloadAsCsvFileWithHeaders } from 'utils/csv';
import { formatCsvFilenameWithDate } from 'modules/intelligentInsights/domain.utils';
import { TimespanEnum } from 'modules/intelligentInsights/types';
import { addPositiveToast } from 'modules/toastContainer';

const Header = styled.h5`
  ${heading5};
  margin-bottom: 0;
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${spacing.eighth};
  align-items: center;
  margin-bottom: ${spacing.base};
`;
export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const StyledTooltip = styled(Tooltip)`
  padding-top: ${spacing.threeEights}
`;

export const createPerformanceFileName =
  (timespan: TimespanEnum) => (formattedDateString: string) => {
    return `froperformanceovertime_${timespan}_days_${formattedDateString}.csv`;
  };

export const PEFORMANCE_OVER_TIME_HEADER_TEST_ID = 'performance-over-time-header';

export const PerformanceOverTimeHeader = () => {
  const dispatch = useDispatch();

  const {
    isLoading,
    froInsightsData,
    timeSpan: { selectedTimespan },
  } = useFroInsightsCoreContext();
  const csvData = getPerformanceDataExport(froInsightsData);

  const onDownloadCsv = () => {
    downloadAsCsvFileWithHeaders({
      headers: PERFORMANCE_OVER_TIME_EXPORT_HEADERS,
      data: csvData,
      fileName: formatCsvFilenameWithDate(createPerformanceFileName(selectedTimespan)),
    });
    dispatch(addPositiveToast(PERFORMANCE_OVER_TIME_EXPORT_SUCCESS));
  };

  return (
    <HeaderWrapper data-test={PEFORMANCE_OVER_TIME_HEADER_TEST_ID}>
      <StyledTitle>
        <Header>{PERFORMANCE_OVER_TIME}</Header>
        <StyledTooltip tooltipContent={PERFORMANCE_OVER_TIME_TOOLTIP}>
          <Help16 />
        </StyledTooltip>
      </StyledTitle>
      <div>
        {!isLoading && (
          <Button
            variant={BUTTON_VARIANTS.SECONDARY}
            onClick={onDownloadCsv}
            size={BUTTON_SIZES.SMALL}
          >
            <Export16 />
            {EXPORT_CSV}
          </Button>
        )}
      </div>
    </HeaderWrapper>
  );
};
